<app-common-page-title *ngIf="detectDeviceService.isDesktop()" icon="assets/playbison/icons/icon-menu-promotions.svg"> <ng-container i18n>Switch ON Bison</ng-container> </app-common-page-title>
<div *ngIf="!infoData else reactive">
    <app-inner-loader></app-inner-loader>
</div>
<ng-template #reactive>
    <div class="day_infopage_container" *ngIf="infoData">
        <div class="badge-container batch-bg" *ngIf="!detectDeviceService.isDesktop()">
            <span i18n>Day {{infoData.currentRecursivePointer}}</span>
        </div>
        <app-close-dialog-button (closeEvent)="closeDialog()" *ngIf="!detectDeviceService.isDesktop()" [customClass]="'large'"></app-close-dialog-button>
        <div class="day_infopage_content_1">
            <div class="day_infopage_heading" *ngIf="detectDeviceService.isDesktop()">
                <h4 i18n>{{infoData[infoDataIndex].displayName}}</h4>
                <p i18n>{{infoData[infoDataIndex].description}}</p>
            </div>
            <div class="day_infopage_img">
                <img [src]="infoData[infoDataIndex].desktopThumbnail.url" alt="no image">
            </div>
            <div class="cta-btn-container" *ngIf="detectDeviceService.isDesktop()">
                <button (click)="ctaRoute()" round-button size="large" filled="filled" color="accent" i18n>{{infoData[infoDataIndex].cta}}</button>
            </div>
        </div>
        <div class="day_infopage_content_2">
            <div class="day_infopage_days">
                <div [class.active]="infoData.currentRecursivePointer === 1" [class.disabled]="infoData.currentRecursivePointer > 1">
                    <p>Day <span>1</span></p>
                </div>
                <div [class.active]="infoData.currentRecursivePointer === 2" [class.disabled]="infoData.currentRecursivePointer > 2">
                    <p>Day <span>2</span></p>
                </div>
                <div [class.active]="infoData.currentRecursivePointer === 3" [class.disabled]="infoData.currentRecursivePointer > 3">
                    <p>Day <span>3</span></p>
                </div>
                <div [class.active]="infoData.currentRecursivePointer === 4" [class.disabled]="infoData.currentRecursivePointer > 4">
                    <p>Day <span>4</span></p>
                </div>
                <div [class.active]="infoData.currentRecursivePointer === 5" [class.disabled]="infoData.currentRecursivePointer > 5">
                    <p>Day <span>5</span></p>
                </div>
                <div [class.active]="infoData.currentRecursivePointer === 6" [class.disabled]="infoData.currentRecursivePointer > 6">
                    <p>Day <span>6</span></p>
                </div>
                <div [class.active]="infoData.currentRecursivePointer === 7" [class.disabled]="infoData.currentRecursivePointer > 7">
                    <p>Day <span>7</span></p>
                </div>
            </div>
            <div class="cta-btn-container" *ngIf="!detectDeviceService.isDesktop()">
                <button (click)="ctaRoute()" round-button size="large" filled="filled" color="accent" i18n>{{infoData[infoDataIndex].cta}}</button>
            </div>
            <div class="day_infopage_heading-mobile" *ngIf="!detectDeviceService.isDesktop()">
                <h4 i18n>{{infoData[infoDataIndex].displayName}}</h4>
                <p i18n>{{infoData[infoDataIndex].description}}</p>
            </div>
            <div class="day_infopage_infocontent" [ngClass]="(detectDeviceService.isDesktop()) ? 'desktop': 'mobile'">
                <div class="infocontent_text_2" [innerHTML]="infoData[infoDataIndex].page.content.html | safeHtml"></div>
            </div>
        </div>
    </div>
</ng-template>